import { useState, useEffect } from "react";
import { Container, Row, Col, Card, CardBody, CardTitle } from "reactstrap";
import { useHistory } from "react-router-dom";
import { connect } from "react-redux";

import { fetchDetailsSubscription } from "redux/Payments/PaymentsActions";
import { useDispatch } from "react-redux";

const HomePage = (props) => {
    
    const dispatch = useDispatch()
        
    useEffect(() => {
        if(typeof props.userDetails.subsId != "undefined"){
        dispatch(fetchDetailsSubscription({ subsId : props.userDetails.subsId }))
        }
        
    }, [])

    const history = useHistory();
    
    const cardHoverStyle = {
        transition: 'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
        cursor: 'pointer'
    };

    const handleClick = (path) => (e) => {
        e.preventDefault();
        e.stopPropagation();
        
        // Simple navigation approach
        history.push(path);
    };

    return(
        <>
            <div className="header bg-gradient-info pt-5 pb-8 pt-md-8">
                <Container fluid>
                    <div className="header-body">
                        <h1 className="text-white mb-3">Welcome to PreDental Tracker!</h1>
                        <Row>
                            <Col  xl="4" className="d-flex">
                                <Card 
                                    className="card-stats mb-4 mb-xl-0 w-100"
                                    style={cardHoverStyle}
                                    onClick={handleClick('/client/dashboard')}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.transform = 'scale(1.05)';
                                        e.currentTarget.style.boxShadow = '0 10px 25px rgba(0, 0, 0, 0.15)';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.transform = 'scale(1)';
                                        e.currentTarget.style.boxShadow = '';
                                    }}
                                >
                                    <CardBody>
                                        <Row>
                                            <Col className="col-auto">
                                                <div className="icon icon-shape bg-primary text-white rounded-circle shadow">
                                                    <i className="ni ni-tv-2 " />
                                                </div>
                                            </Col>
                                            <div className="col">
                                                <CardTitle
                                                    tag="h4"
                                                    className="font-weight-bold text-uppercase mb-0"
                                                >
                                                    Student Overview
                                                </CardTitle>
                                                <span className="h6 text-muted mb-0">See your overview here</span>
                                            </div>
                                        </Row>
                                    </CardBody>
                                </Card>
                            </Col>
                            <Col  xl="4" className="d-flex">
                                <Card 
                                    className="card-stats mb-4 mb-xl-0 w-100"
                                    style={cardHoverStyle}
                                    onClick={handleClick('/client/community')}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.transform = 'scale(1.05)';
                                        e.currentTarget.style.boxShadow = '0 10px 25px rgba(0, 0, 0, 0.15)';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.transform = 'scale(1)';
                                        e.currentTarget.style.boxShadow = '';
                                    }}
                                >
                                    <CardBody>
                                        <Row>
                                            <Col className="col-auto">
                                                <div className="icon icon-shape bg-success text-white rounded-circle shadow">
                                                    <i className="fas fa-users " />
                                                </div>
                                            </Col>
                                            <div className="col">
                                                <CardTitle
                                                    tag="h4"
                                                    className="font-weight-bold text-uppercase mb-0"
                                                >
                                                   Study Community
                                                </CardTitle>
                                                <span className="h6 text-muted mb-0">See what community members are up to</span>
                                            </div>
                                        </Row>
                                    </CardBody>
                                </Card>
                            </Col>
                            <Col  xl="4" className="d-flex">
                                <Card 
                                    className="card-stats mb-4 mb-xl-0 w-100"
                                    style={cardHoverStyle}
                                    onClick={handleClick('/client/performance')}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.transform = 'scale(1.05)';
                                        e.currentTarget.style.boxShadow = '0 10px 25px rgba(0, 0, 0, 0.15)';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.transform = 'scale(1)';
                                        e.currentTarget.style.boxShadow = '';
                                    }}
                                >
                                    <CardBody>
                                        <Row>
                                            <Col className="col-auto">
                                                <div className="icon icon-shape bg-info text-white rounded-circle shadow">
                                                    <i className="fas fa-chart-line " />
                                                </div>
                                            </Col>
                                            <div className="col">
                                                <CardTitle
                                                    tag="h4"
                                                    className="font-weight-bold text-uppercase mb-0"
                                                >
                                                   Start Performance
                                                </CardTitle>
                                                <span className="h6 text-muted mb-0">See your performance analytics here</span>
                                            </div>
                                        </Row>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </div>
                </Container>
                
            </div>
           
        </>
    )

}
const mapStateToProps = state => {
  return {
    userDetails : state.loginAuth.userDetails,
    updateUserPhoneNumber : state.updateUserPhoneNumber
  }
}


export default connect(mapStateToProps)(HomePage)